import trackEvent from "@analytics/utils/trackEvent";

const MarketingSummaryAnalyticsService = {
  trackCopyResponseClicked: () => trackEvent("Marketing Summary Copied"),
  trackFileRemoved: () => trackEvent("Marketing Summary File Removed"),
  trackFileUploaded: () => trackEvent("Marketing Summary File Uploaded"),
  trackMarketingSummaryDeleted: () => trackEvent("Marketing Summary Deleted"),
  trackModalOpened: (modalType: string) => trackEvent("Modal Opened", { modal_type: modalType }),
  trackSummaryMessageSent: () => trackEvent("Marketing Summary Message Sent"),
  trackSummaryNegativelyRated: (promptType: string, issue: string, feedback: string) =>
    trackEvent("Summary Negatively Rated", {
      feedback,
      issue,
      prompt_type: promptType,
    }),
  trackSummaryPositivelyRated: () => trackEvent("Summary Positively Rated"),
} as const;

export default MarketingSummaryAnalyticsService;
